import React from 'react';
import Slider from 'react-slick';
import { Box, Typography, Container, Grid, Card, CardContent } from '@mui/material';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Список изображений для слайдера
const images = [
  '/images/about/a0.jpg',
  '/images/about/a1.jpg',
  '/images/about/a2.jpg',
  '/images/about/a3.jpg',
  '/images/about/a4.jpg',
  '/images/about/a5.jpg',
  '/images/about/a6.jpg',
  '/images/about/a7.jpg',
  '/images/about/a8.jpg',
  '/images/about/a9.jpg',
  //'/images/about/a10.jpg',
  '/images/about/a11.jpg',
  '/images/about/a12.jpg',
  // Добавьте сюда пути к вашим изображениям
];

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
};

const AboutPage = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Grid container spacing={5}>
        <Grid item xs={12} md={6}>
          <Card sx={{ display: 'flex', flexDirection: 'column', height: '100%', boxShadow: 'none', border: 'none' }}>
            <Slider {...sliderSettings}>
              {images.map((image, index) => (
                <Box key={index} sx={{ width: '100%' }}>
                  <img 
                    src={image} 
                    alt={`slide-${index}`} 
                    loading={index === 0 ? "eager" : "lazy"}
                    style={{ 
                      width: '100%', 
                      height: 'auto',
                      objectFit: 'cover',
                      borderRadius: '10px' 
                    }}
                  />
                </Box>
              ))}
            </Slider>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card sx={{ height: '100%', border: 'none', boxShadow: 'none' }}>
            <CardContent>
              <Typography variant="h3" gutterBottom>
                О НАС
              </Typography>

              <Typography variant="body1" paragraph sx={{ fontWeight: 600 }}>
                «Хочу Цветочки» — цветочный салон, который с 2017 года радует жителей Тольятти свежими цветами и авторскими букетами.
              </Typography>
              <Typography variant="body1" paragraph>
                С первого дня мы работаем по одному правилу: только самые красивые и свежие цветы. Мы не собираем шаблонные букеты «на поток». Каждая композиция создаётся так, как мы сделали бы её для самых близких людей.
              </Typography>

              <Typography variant="h5" gutterBottom sx={{ color: '#f2003c', mt: 4 }}>
                Прямые поставки с плантаций
              </Typography>
              <Typography variant="body1" paragraph>
                Мы сами посещаем международные выставки и плантации и работаем с производителями напрямую. Цветы приезжают к нам из Эквадора, Кении, Колумбии и Нидерландов без лишних посредников. Поэтому качество у нас выше, а цены ниже, чем в среднем по городу. Кроме того, прямые поставки позволяют нам привозить редкие и интересные сорта роз, кустовых роз и других цветов, которые сложно найти в обычных магазинах.
              </Typography>

              <Typography variant="h5" gutterBottom sx={{ color: '#f2003c', mt: 4 }}>
                Команда профессионалов
              </Typography>
              <Typography variant="body1" paragraph>
                Над букетами работают опытные флористы, которые чувствуют цвет, форму и настроение. Мы доверяем им самые важные заказы и уверены в результате.
              </Typography>

              <Typography variant="h5" gutterBottom sx={{ color: '#f2003c', mt: 4 }}>
                Наши принципы
              </Typography>
              <Box
                component="ul"
                sx={{
                  m: 0,
                  mb: 3,
                  pl: 3,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1,
                  '& li': {
                    fontSize: '1rem',
                    lineHeight: 1.6,
                  },
                  '& li::marker': {
                    color: '#f2003c',
                  },
                }}
              >
                <li>Собираем букеты, как для своих близких.</li>
                <li>Работаем только с профессиональными флористами.</li>
                <li>Выбираем лучшие цветы напрямую у производителей.</li>
                <li>Доставляем бережно, чтобы букет дольше оставался свежим.</li>
              </Box>

              <Typography variant="body1" paragraph sx={{ fontStyle: 'italic' }}>
                Приходите в «Хочу Цветочки» и почувствуйте, с какой заботой создаётся каждый букет.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default AboutPage;
